export const WHATSAPP_COMMON_QUERY_KEYS = {
  Z_API_INSTANCES: 'common-z-api-instances',
};

export const WHATSAPP_ADMIN_QUERY_KEYS = {
  Z_API_INSTANCES: 'admin-z-api-instances',
};
